import { RankingsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { OLY_RANKINGS_API_URL } = process.env;

export default new RankingsApi(OLY_RANKINGS_API_URL, { fromAdmin: true }, olyEngineApi);
